



























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import EspecialidadeModel from "@/models/cadastros/saude/EspecialidadeModel";
import { tiposRamoList } from "@/models/cadastros/saude/RamoModel";
import { tiposAtendimentoList } from "@/models/cadastros/saude/TipoAtendimentoModel";
import { saudeEspecialidadeService } from "@/service/cadastro/saude/especialidade/SaudeEspecialidadeService";
import MessageDialog from "@/components/modal/MessageDialog.vue";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    MessageDialog,
  },
})
export default class CadastroEspecialidade extends Vue {
  $refs!: {
    cadastroObserver: InstanceType<typeof ValidationObserver>;
  };

  tiposRamo = tiposRamoList;
  tiposAtendimento = tiposAtendimentoList;
  especialidade = {};

  openDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  dialogStyle = "";
  dialogType = "";
  dialogKey = 0;
  dialog = false;

  acaoDialog(tipo: string) {
    if (tipo == "sucesso") {
      this.$router.push({ name: "ListaEspecialidades" });
    } else {
      this.openDialog = false;
    }
  }

  gravar() {
    this.$refs.cadastroObserver.validate().then((valid) => {
      if (valid) {
        if (this.$route.params.idEspecialidade) {
          saudeEspecialidadeService
            .atualizar(
              this.especialidade,
              new Number(this.$route.params.idEspecialidade)
            )
            .then((res: any) => {
              this.dialogTitle = "Alteração realizada com sucesso";
              this.dialogMessage = "Especialidade realizada com sucesso";
              this.dialogStyle = "success";
              this.dialogType = "sucesso";
              this.openDialog = true;
            })
            .catch((err: any) => {
              this.dialogTitle = "Erro";
              this.dialogMessage = err;
              this.dialogStyle = "error";
              this.dialogType = "";
              this.openDialog = true;
            });
        } else {
          saudeEspecialidadeService
            .salvar(this.especialidade)
            .then((res) => {
              this.dialogTitle =
                "Cadastro de especialidade realizado com sucesso";
              this.dialogMessage =
                "Cadastro de especialidade realizado com sucesso";
              this.dialogStyle = "success";
              this.dialogType = "sucesso";
              this.openDialog = true;
            })
            .catch((err) => {
              this.dialogTitle = "Erro";
              this.dialogMessage = err;
              this.dialogStyle = "error";
              this.dialogType = "";
              this.openDialog = true;
            });
        }
      }
    });
  }

  mounted() {
    this.loadInfo();
  }

  loadInfo() {
    if (this.$route.params.idEspecialidade) {
      saudeEspecialidadeService
        .obterPorId(new Number(this.$route.params.idEspecialidade))
        .then((res) => {
          this.especialidade = {
            id: res.id,
            nome: res.nome,
            tipoAtendimento: this.tiposAtendimento?.find(
              (tipo) => tipo?.name == res?.tipoAtendimento
            ),
            ramo: this.tiposRamo?.find((tipo) => tipo?.name == res?.ramo),
            orientacaoPreparo: res.orientacaoPreparo,
          };
        });
    }
  }
}
